<div class="center">
  <div>
  <img class="vend-logo" src="../../../../../../assets//pos/vend.png">
  <div class="waiting">{{'onboarding.messages.finishing_off' | translate}}</div>
  </div>
</div>